import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function News() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Stay updated with the latest luxury lifestyle news and trends on First-Class.com. Explore fashion, wellness, and more'
          }
        />
        <title>Lifestyle News: Stay Informed on Luxury Living</title>
      </Head>
      <ArticlesList subtype="News" type="Lifestyle" />
    </>
  );
}

export default withLayout(News, true);
